








































































































































































































import LazyHydrate from 'vue-lazy-hydration';
import { SfAddToCart, SfAlert, SfButton, SfColor, SfGallery, SfHeading, SfLoader, SfModal, SfPrice, SfRating, SfSelect } from '@storefront-ui/vue';
import {
  computed,
  defineComponent,
  onMounted,
  PropType,
  ref,
  toRef,
  useContext,
  useRoute,
  useRouter,
  watch
} from '@nuxtjs/composition-api';

import {
  getName as getProductName,
  getPrice as getProductPrice,
  getSwatchData as getProductSwatchData,
} from '~/modules/catalog/product/getters/productGetters';

import { getAverageRating, getTotalReviews, } from '~/modules/review/getters/reviewGetters';

import { useCart } from '~/modules/checkout/composables/useCart';
import SvgImage from '~/components/General/SvgImage.vue';
import HTMLContent from '~/components/HTMLContent.vue';
import { useUser } from '~/modules/customer/composables/useUser';
import { getConfigurableProductSpecialPriceCommand } from '~/modules/catalog/pricing/getConfigurableProductSpecialPriceCommand';
import { Product } from '~/modules/catalog/product/types';
import ProductTabs from '~/modules/catalog/product/components/tabs/ProductTabs.vue';
import { useProductGallery } from '~/modules/catalog/product/composables/useProductGallery';
import { TabsConfig, useProductTabs } from '~/modules/catalog/product/composables/useProductTabs';
import CromologyColorPicker from '~/modules/catalog/product/components/CromologyColorPicker';
import PictimeProductSheet from '../../../../../../components/organisms/PictimeProductSheet.vue';
import PictimeFlap from '../../../../../../components/molecules/PictimeFlap';
import PictimePrice from '../../../../../../components/molecules/PictimePrice';
import PictimeStockExtended from '../../../../../../components/molecules/PictimeStockExtended';
import PictimeAddToCart from '../../../../../../components/molecules/PictimeAddToCart';
import PictimeQuantitySelector from '../../../../../../components/molecules/PictimeQuantitySelector';
import PriceLoader from '../../../../../../components/atoms/PriceLoader';
import calculFlap from '~/helpers/utils/calculFlap';
import calculStock from '~/helpers/utils/calculStock';
import { cacheQuote, cacheRole } from '~/helpers/customer/role.ts';
import { useUiState } from '~/composables';
import { useCartStore } from '~/modules/checkout/stores/cart';
import { useCustomerStore } from '~/modules/customer/stores/customer';
import { useProductStore } from '~/modules/catalog/product/stores/product';
import { useCancelRequestForApproval } from '~/modules/checkout/composables/useCancelRequestForApproval';
import PendingApprovalModal from '~/components/molecules/PendingApprovalModal.vue';
import AddToWishlist from '~/modules/wishlist/components/AddToWishlist';
import { useWishlistStore } from '~/modules/wishlist/store/wishlistStore';
import ProductStocks from "~/modules/catalog/product/components/ProductStocks.vue";

export default defineComponent({
  name: 'SimpleProduct',
  components: {
		ProductStocks,
    AddToWishlist,
    HTMLContent,
    LazyHydrate,
    SfAddToCart,
    SfButton,
    SfColor,
    SfGallery,
    SfHeading,
    SfLoader,
    SfPrice,
    SfRating,
    SfSelect,
    SfAlert,
    SvgImage,
    ProductTabs,
    PictimeProductSheet,
    PictimeFlap,
    PictimePrice,
    PictimeStockExtended,
    PictimeAddToCart,
    PictimeQuantitySelector,
    CromologyColorPicker,
    PriceLoader,
    PendingApprovalModal,
    AddToCartSidebar: () => import(/* webpackPrefetch: true */ '~/components/AddToCartSidebar.vue'),
    SfModal
  },
  transition: 'fade',
  props: {
    product: {
      type: [Object, null] as PropType<Product>,
      default: null,
    },
    productAssets: {
      type: [Array, Object, String],
      default: () => ['']
    },
    productType: {
      type: String,
      default: 'Peintures pro'
    },
    documentsCount: {
      type: Number,
      default: 0
    },
    isFetching: {
      type: Boolean,
      default: true,
    },
    priceLoading: {
      type: Boolean,
      default: true
    },
    testerLink: {
      type: String,
      default: '',
    },
    configurableProductConfiguration: {
      type: Object,
      default: () => ({}),
    },
    productFeatures: {
      type: Object,
      default: () => ({})
    },
    documents: {
      type: Array,
      default: {}
    }
  },
  data() {
    return {
      openPicker: false,
    }
  },
  setup(props, { emit }) {
    const {
      isAddToCartSidebarOpen,
      toggleAddToCartSidebar,
      toggleAddToWishlistSidebar,
      isPendingModalOpen,
      togglePendingModal,
      isQtyCalculatorSidebarOpen
    } = useUiState();
    const { hasApprovalOrder } = cacheQuote();
    const qty = ref(1);
    const variant_sku = ref('');
    const product = toRef(props, 'product');
    const route = useRoute();
    const router = useRouter();
    const productStore = useProductStore();
    const {
      addItem,
      error: cartError,
      loading: isCartLoading,
      load: loadCart,
      canAddToCart,
      cart: cartInstant,
      setCart
    } = useCart();
    const { productGallery, imageSizes } = useProductGallery(product);
    const { localePath } = useContext();

    const customProductGallery = computed(() => getProductGallery());

    const isIconHover = ref(false);
    const icon = computed(() => isIconHover.value ? 'heart_fill' : 'heart')

    function getProductGallery() {
      let res = [];

      Object.keys(props.configurableProductConfiguration?.items).forEach((item) => {
        if (props.configurableProductConfiguration.items[item].sku == props.product.sku) {
          if (props.configurableProductConfiguration.items[item].designPicture) {
            res.push(props.configurableProductConfiguration.items[item].designPicture);
          }
          if (props.configurableProductConfiguration.items[item].application_photos) {
            res.push(props.configurableProductConfiguration.items[item].application_photos);
          }
          if (props.configurableProductConfiguration.items[item].application_photos_2) {
            res.push(props.configurableProductConfiguration.items[item].application_photos_2);
          }
          if (props.configurableProductConfiguration.items[item].application_photos_3) {
            res.push(props.configurableProductConfiguration.items[item].application_photos_3);
          }
          if (props.configurableProductConfiguration.items[item].application_photos_4) {
            res.push(props.configurableProductConfiguration.items[item].application_photos_4);
          }
          if (props.configurableProductConfiguration.items[item].application_photos_5) {
            res.push(props.configurableProductConfiguration.items[item].application_photos_5);
          }
          if (props.configurableProductConfiguration.items[item].application_photos_6) {
            res.push(props.configurableProductConfiguration.items[item].application_photos_6);
          }
          if (props.configurableProductConfiguration.items[item].application_photos_7) {
            res.push(props.configurableProductConfiguration.items[item].application_photos_7);
          }
        }
      });

      let ret = [];
      Object.keys(res).forEach((item) => {
        ret.push(
          {
            mobile: { url: res[item] },
            desktop: { url: res[item] },
            big: { url: res[item] },
            // eslint-disable-next-line no-underscore-dangle
            alt: product.value.name
          });
      });

      return ret;
    }

    const { activeTab, setActiveTab, openNewReviewTab } = useProductTabs();

    const { isAuthenticated, load, user } = useUser();
    const isAuth = ref(false);
    const { app } = useContext();

    const productShortDescription = computed(
      () => props.configurableProductConfiguration?.shortDescription || '',
    );

    const configurableOptions = computed(
      () => props.product?.configurable_options ?? [],
    );

    const currentTint = props.product.color;
    const selectedConditioningLabel = currentTint;
    const productConfiguration = ref(route.value.query);
    const productSpecialPrice = computed(() => getConfigurableProductSpecialPriceCommand(props.product));

    const variantDatas = ref([]);
    const variant_datas = computed({
      get() {
        return variantDatas.value;
      },
      set(newValue) {
        variantDatas.value = newValue['variant_datas'];
      }
    });

    const getTaxe = (isAuth) => {
      return !isAuth ? ' TTC' : ' HT'
    };

    const { params: { slug } } = route.value;
    const getBaseSearchQuery = () => ({
      filter: {
        url_key: {
          eq: slug,
        },
      },
      configurations: Object.entries(productConfiguration.value).map(
        (config) => config[1],
      ) as string[],
    });

    const totalReviews = computed(() => getTotalReviews(props.product));
    const averageRating = computed(() => getAverageRating(props.product));
    const addToCartError = computed(() => cartError.value?.addItem?.message);

    const updateProductConfiguration = (label: string, value: string, sku: string, quantity: number) => {
      disableAddToCart.value = false;
      variant_sku.value = sku;

      if (productConfiguration.value[label] === value) return;

      productConfiguration.value[label] = value;
      const routeData = router.resolve({
        path: `${app.localePath(window.location.pathname)}`,
        query: {
          ...productConfiguration.value,
        },
      });

      window.history.pushState({}, null, routeData.href);

      emit('fetchProduct', { query: getBaseSearchQuery(), sku: sku, quantity: quantity });
    };

    const addItemToCart = async (product, qty) => {
      let customisation = [];
      let isCustom = false;

      if (isAlreadyApprovalOrder.value) {
        togglePendingModal()

      } else {
        disableAddToCart.value = true;
        const pricingUnit = props.product?.pricingUnit || '';
        await addItem({ product, quantity: parseInt(qty), customisation, isCustom, pricingUnit });

        if (!addToCartError.value) {
          productStore.setProductModal(
            {
              id: product.sku,
              articleCode: props.product.articleCode,
              color: currentTint,
              image: mainPicture.value,
              name : props.product.name,
              quantity: qty,
              taxe: getTaxe(isAuth.value),
              total: isAuth.value ? Math.round((props.product.priceExcludingTax.packagingFinalPrice * qty) * 100)/100 : Math.round((props.product.priceIncludingTax.packagingFinalPrice * qty) * 100)/100,
              type: product.productType
            }
          )

          toggleAddToCartSidebar();
          disableAddToCart.value = false;
        }
      }
    };

    const configurationData = ref({});
    const configuration_data = computed({
      get() {
        return configurationData.value;
      },
      set(newValue) {
        configurationData.value = newValue['configuration_data'];
      }
    });

    const articleIds = ref([]);

    const getDatas = async () => {
      let codes = [];
      configurationData.value = props.configurableProductConfiguration;
      configurationData.value.__typename = 'ConfigurableProduct';

      if (configurationData.value) {
        Object.keys(configurationData.value.items).forEach((item) => {
          codes.push(configurationData.value.items[item].articleCode);
        });
      }

      codes = codes.filter(function (el) {
        return el != null;
      });

      articleIds.value = codes;
    };

    const disableAddToCart = ref(true);

    const getData = async () => {
      await getDatas();
      if (configuration_data.value) {
        createVariantDataArray(configuration_data.value);
        setDefaultVariant(configuration_data.value);
      }
    };

    getData();

    function setDefaultVariant(result) {
      if (result) {
        Object.keys(result?.items).forEach((item) => {
          if (result.items[item].sku == props.product.sku) {
            updateProductConfiguration(configurationData.value.configurableAttributeUid, result.items[item].configurableAttributeUid, props.product.sku, qty.value);
          }
        });
      }
    }

    const mainPicture = ref({ url: '', label: '' });

    function createVariantDataArray(result) {
      let variantDatas = [];

      Object.keys(result.items).forEach((item) => {
        if (result.items[item]?.sku === props.product.sku) {
          mainPicture.value.label = result.items[item]?.name ? result.items[item]?.name : '';
          mainPicture.value.url = result.items[item]?.designPicture ? result.items[item]?.designPicture : '';
        }
        variantDatas.push({
          picture: result.items[item].thumbnail,
          isSelected: result.items[item].sku == props.product.sku,
          sku: result.items[item].sku,
          name: result.items[item].name,
          urlKey: result.items[item].urlKey
        });
      });

      variant_datas.value = {
        variant_datas: variantDatas
      };
    }

    watch(qty, (qty, prevQty) => {
      emit('fetchProduct', { query: getBaseSearchQuery(), sku: variant_sku.value, quantity: qty });
    });

    // Partie sous-compte
    const cartStore = useCartStore();
    const customerStore = useCustomerStore();
    const { isSubAccount } = cacheRole();
    const currentShop = computed(() => customerStore.getCurrentShopCode)
    const cart = ref(cartStore.$state.cart);
    const { save: cancelForApproval } = useCancelRequestForApproval();
    const firstnameDirigeant = ref('');
    const lastnameDirigeant = ref('');
    const isAlreadyApprovalOrder = ref(false);

    if (isSubAccount.value === true) {
      if (user.value === null) {
        load();
      } else {
        firstnameDirigeant.value = user.value.dirigeant?.firstname;
        lastnameDirigeant.value = user.value.dirigeant?.lastname;
      }
    }

    const sendCancelForApproval = async () => {
      const result = await cancelForApproval({
        cart_id: cartStore.$state.cart?.id
      });
      if (result.data.cancelRequestForApproval.cart_id) {
        togglePendingModal();
        isAlreadyApprovalOrder.value = false;
      }
    };

    onMounted(async () => {
      isAuth.value = await isAuthenticated();

      if (isSubAccount.value) {
        if (!cart.value.id) {
          await loadCart({ customQuery: { cart: 'customCart' } });
          setCart(cartInstant.value);
          cart.value = cartStore.$state.cart;
        }

        isAlreadyApprovalOrder.value = hasApprovalOrder(cart.value);
      }
    });

    function goToProduct(urlKey) {
      router.push(
        localePath({ name: 'product', params: { slug: urlKey } })
      );
    }

    const wishlistStore = useWishlistStore()

    const toggleWishlist = async () => {
      wishlistStore.setProductAdded({
        id: product.value.sku,
        product: product.value,
        selectedOptionsUids: [],
        enteredOption: [],
        articleCode: product.value.articleCode,
        color: currentTint,
        conditioning: undefined,
        type: props.productType
      })

      toggleAddToWishlistSidebar();
    }

    return {
      addItem,
      canAddToCart,
      configurableOptions,
      updateProductConfiguration,
      isAuth,
      isCartLoading,
      productConfiguration,
      productGallery,
      getProductName,
      getProductPrice,
      getProductSwatchData,
      productShortDescription,
      productSpecialPrice,
      qty,
      totalReviews,
      averageRating,
      imageSizes,
      setActiveTab,
      openNewReviewTab,
      activeTab,
      TabsConfig,
      addToCartError,
      customProductGallery,
      getTaxe,
      articleIds,
      configurationData,
      disableAddToCart,
      calculFlap,
      calculStock,
      watch,
      variant_sku,
      isAddToCartSidebarOpen,
      toggleAddToCartSidebar,
      addItemToCart,
      firstnameDirigeant,
      lastnameDirigeant,
      isPendingModalOpen,
      togglePendingModal,
      isAlreadyApprovalOrder,
      sendCancelForApproval,
      currentShop,
      currentTint,
      variantDatas,
      goToProduct,
      mainPicture,
      isQtyCalculatorSidebarOpen,
      selectedConditioningLabel,
      toggleWishlist,
      icon,
      isIconHover,
    };
  },
});
